import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import NotFound from "./pages/NotFound";
import MainDashboard from './pages/main-dashboard';
import CreateIncident from './pages/create-incident';
import AccountSettings from './pages/account-settings';
import IncidentsList from './pages/incidents-list';
import SystemSettings from './pages/system-settings';
import ReportsAnalytics from './pages/reports-analytics';
import IncidentDetailsPage from './pages/incident-details';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/login';
import BlocksList from "pages/blocks";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<NotFound />} />
        
        {/* Protected Routes - These now require a user to be logged in */}
        <Route path="/" element={<ProtectedRoute element={<MainDashboard />} />} />
        <Route path="/main-dashboard" element={<ProtectedRoute element={<MainDashboard />} />} />
        <Route path="/create-incident" element={<ProtectedRoute element={<CreateIncident />} />} />
        <Route path="/account-settings" element={<ProtectedRoute element={<AccountSettings />} />} />
        <Route path="/incidents-list" element={<ProtectedRoute element={<IncidentsList />} />} />
        <Route path="/system-settings" element={<ProtectedRoute element={<SystemSettings />} />} />
        <Route path="/reports-analytics" element={<ProtectedRoute element={<ReportsAnalytics />} />} />
        <Route path="/incident-details" element={<ProtectedRoute element={<IncidentDetailsPage />} />} />
        <Route path="/blocks" element={<ProtectedRoute element={<BlocksList />} />} />

      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
